import React, { useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material'

import { ContactInfo, ContactStepProps } from '../types'

const ContactStep: React.FC<ContactStepProps> = ({ value, onChange, error }) => {
  const [phoneCountryCode, setPhoneCountryCode] = useState<'+86' | '+1'>('+86')
  const [phoneError, setPhoneError] = useState('')

  const validatePhone = (phoneNumber: string, countryCode: string) => {
    if (!phoneNumber) return ''

    if (countryCode === '+86') {
      if (!/^\d{11}$/.test(phoneNumber)) return '请输入 11 位中国手机号'
    } else if (countryCode === '+1') {
      if (!/^\d{10}$/.test(phoneNumber)) return '请输入 10 位美国手机号'
    }
    return ''
  }

  const handleWechatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      wechat: event.target.value,
    })
  }

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const phoneNumber = event.target.value
    const formattedPhone = phoneNumber ? `${phoneCountryCode}${phoneNumber}` : ''

    onChange({
      ...value,
      phone: formattedPhone,
    })

    const error = validatePhone(phoneNumber, phoneCountryCode)
    setPhoneError(error)
  }

  const handleCountryCodeChange = (event: SelectChangeEvent<'+86' | '+1'>) => {
    const newCountryCode = event.target.value as '+86' | '+1'
    setPhoneCountryCode(newCountryCode)

    if (value.phone) {
      const currentPhone = value.phone.replace(/^\+\d+/, '')
      const formattedPhone = `${newCountryCode}${currentPhone}`
      onChange({
        ...value,
        phone: formattedPhone,
      })

      const error = validatePhone(currentPhone, newCountryCode)
      setPhoneError(error)
    }
  }

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      email: event.target.value,
    })
  }

  // const getPhoneNumber = () => {
  //   return value.phone.replace(/^\+\d+/, '')
  // }

  const hasRequiredContact = value.wechat || value.phone

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-bold text-[#1d2129] leading-snug">5. 联系方式（便于发送房源推荐）</h2>
      </div>

      <div className="flex flex-col gap-4">
        {/* 微信号 */}
        <div className="flex flex-col gap-2">
          <span className="text-[#050a22] text-sm font-medium">微信号</span>
          <TextField
            id="wechat"
            value={value.wechat}
            onChange={handleWechatChange}
            placeholder="请输入微信号"
            fullWidth
            size="small"
            InputProps={{
              sx: {
                backgroundColor: 'white',
                borderRadius: '8px',
                '& fieldset': {
                  borderColor: '#e0e2ef',
                },
              },
            }}
          />
        </div>

        {/* 手机号 */}
        <div className="flex flex-col gap-2">
          <span className="text-[#050a22] text-sm font-medium">手机号（中国或美国均可）</span>
          <div className="flex gap-2">
            <FormControl size="small" sx={{ width: '110px' }}>
              <Select
                value={phoneCountryCode}
                onChange={handleCountryCodeChange}
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  '& fieldset': {
                    borderColor: '#e0e2ef',
                  },
                }}
              >
                <MenuItem value="+86">🇨🇳 +86</MenuItem>
                <MenuItem value="+1">🇺🇸 +1</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="phone"
              // value={getPhoneNumber()}
              type="tel"
              onChange={handlePhoneChange}
              placeholder="请输入手机号"
              fullWidth
              size="small"
              error={!!phoneError}
              InputProps={{
                sx: {
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  '& fieldset': {
                    borderColor: '#e0e2ef',
                  },
                },
              }}
            />
          </div>
          {phoneError && <p className="text-red-500 text-sm font-medium">{phoneError}</p>}
        </div>

        {/* 邮箱 */}
        <div className="flex flex-col gap-2">
          <span className="text-[#050a22] text-sm font-medium">邮箱（可选）</span>
          <TextField
            id="email"
            value={value.email}
            onChange={handleEmailChange}
            placeholder="example@email.com"
            fullWidth
            size="small"
            InputProps={{
              sx: {
                backgroundColor: 'white',
                borderRadius: '8px',
                '& fieldset': {
                  borderColor: '#e0e2ef',
                },
              },
            }}
          />
        </div>
      </div>

      {error && !hasRequiredContact && <p className="text-red-500 text-sm font-medium">请至少填写一种联系方式（微信或手机号）</p>}
    </div>
  )
}

export default ContactStep
